import AsyncStorage from '@react-native-async-storage/async-storage';

/**
 * «Удалить у себя» for a single message — we can't server-delete someone else's
 * message, so incoming messages are hidden locally. Set of message ids,
 * in-memory for sync reads, persisted to AsyncStorage.
 */
const KEY = 'chat_deleted_msgs';
let cache = new Set<string>();
let loaded = false;

/** Load persisted locally-deleted message ids (call once early). */
export async function loadDeletedMessages(): Promise<void> {
  if (loaded) return;
  loaded = true;
  try {
    const raw = await AsyncStorage.getItem(KEY);
    if (raw) cache = new Set<string>(JSON.parse(raw));
  } catch {
    /* first run / parse error — empty */
  }
}

/** Sync check — is this message hidden for me? */
export function isMessageDeleted(id: string): boolean {
  return cache.has(id);
}

/** Hide a message for me and persist. Cache updates synchronously. */
export function addDeletedMessage(id: string): void {
  cache.add(id);
  AsyncStorage.setItem(KEY, JSON.stringify([...cache])).catch(() => {});
}
